module.exports = __webpack_public_path__ + "close_black.png?cfb06fed014fb02e909fc5717d343d2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/close_black.png
// module id = 564
// module chunks = 0